import { render, staticRenderFns } from "./modal-select-column.vue?vue&type=template&id=537d0f64&scoped=true"
import script from "./modal-select-column.vue?vue&type=script&lang=js"
export * from "./modal-select-column.vue?vue&type=script&lang=js"
import style0 from "./modal-select-column.vue?vue&type=style&index=0&id=537d0f64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537d0f64",
  null
  
)

export default component.exports